import QRCode from 'qrcode'
import JsBarcode from 'jsbarcode'
import MerchizeImage from "../../assets/images/merchize.png"

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const textToBase64Barcode = (text) => {
    var canvas = document.createElement("canvas")
    JsBarcode(canvas, text, { displayValue: true })
    return canvas.toDataURL("image/png")
}


const LABEL_WIDTH = 1441
const LABEL_HEIGHT = 2161
export default async (opts) => {
    //Information box
    const { id, box_partner_detail, total_packages, name } = { ...opts }
    const { box_number: boxNumberBarcode } = { ...box_partner_detail }
    const boxNumber = `#${id}`

    //QR image
    const qrDataUrl = await QRCode.toDataURL(boxNumber, { width: 500, margin: 0 })
    const qrDataImage = await _makeImage(qrDataUrl)

    //Barcode image
    const data = textToBase64Barcode(boxNumberBarcode)
    const barcodeImage = await _makeImage(data)
    //Created canvas
    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT
    const ctx = canvas.getContext('2d')

    //Init canvas page
    ctx.beginPath()
    ctx.fillStyle = 'white'
    ctx.fill()

    //Draw rect
    ctx.lineWidth = 4
    ctx.rect(45, 45, LABEL_WIDTH - 90, LABEL_HEIGHT - 90)
    ctx.stroke()

    //Draw QR image
    ctx.drawImage(qrDataImage, 450, 750, 300, 300)

    //Draw box number
    ctx.fillStyle = 'black'
    ctx.font = 'bold 60px Arial'
    ctx.fillText(boxNumber, 800, 850)

    //Draw total packages
    ctx.fillStyle = 'black'
    ctx.font = 'bold 55px Arial'
    ctx.fillText(`${total_packages} packages`, 800, 950)

    //Draw line
    ctx.lineWidth = 4
    ctx.setLineDash([10, 10])
    ctx.moveTo(45, LABEL_HEIGHT - 950)
    ctx.lineTo(LABEL_WIDTH - 45, LABEL_HEIGHT - 950)
    ctx.stroke()

    //Draw name
    ctx.fillStyle = 'black'
    ctx.font = 'bold 100px Arial'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(`${!!name ? name : ''}`, canvas.width / 2, canvas.height / 2 + 300)

    //Draw barcode
    var x = canvas.width / 2 - 800 / 2
    var y = canvas.height / 2 - 400 / 2 + 650
    ctx.drawImage(barcodeImage, x, y, 800, 400)

    //Draw merchize
    var imageObj = await _makeImage(MerchizeImage)
    ctx.drawImage(imageObj, 320, 150, 900, 250)

    //Draw text merchize
    ctx.fillStyle = 'black'
    ctx.font = '50px Arial'
    ctx.fillText('Fulfillment Services', 900, 380)

    return canvas.toDataURL()
}
